<div class="insights-container">
  <div class="row row-gutters">
    <div class="col col-xs-12 col-sm-4 col-md-4">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            {{ 'INSIGHTS.SENTIMENT_SCORE' | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <meeting-analysis-statistic
            [score]="conversation()?.interactionReport?.sentimentScore || 0"
            [maxScore]="10"
          ></meeting-analysis-statistic>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col col-xs-12 col-sm-4 col-md-4">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            {{ 'INSIGHTS.PATIENCE' | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <meeting-analysis-statistic
            [score]="conversation()?.interactionReport?.patience || 0"
            [maxScore]="10"
          ></meeting-analysis-statistic>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col col-xs-12 col-sm-4 col-md-4">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            {{ 'INSIGHTS.INTERACTIVITY_SCORE' | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <meeting-analysis-statistic
            [score]="conversation()?.interactionReport?.interactivityScore || 0"
            [maxScore]="10"
          ></meeting-analysis-statistic>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="row row-gutters">
    <div class="col col-xs-12 col-sm-8 col-md-8">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            {{ 'INSIGHTS.SPEAKER_TALK_TIME' | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="full-chart">
            <div class="chart" #chartContainer>
              @if (chartHeight() > 0) {
                <ngx-charts-pie-chart
                  [results]="talkTimeFormatted()"
                  [legend]="false"
                  [customColors]="customColors()"
                  [doughnut]="true"
                  [trimLabels]="false"
                  [maxLabelLength]="100"
                  [arcWidth]="0.3"
                ></ngx-charts-pie-chart>
              }
            </div>
            <div class="legend">
              @for (participant of talkTimeFormatted(); track participant.name) {
                <div class="legend-item">
                  <meeting-analysis-participant
                    [name]="participant.name"
                    [linkToContactPage]="false"
                  ></meeting-analysis-participant>
                  <span class="legend-percentage">({{ participant.value }}%)</span>
                </div>
              }
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col col-xs-12 col-sm-4 col-md-4">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            {{ 'INSIGHTS.KEYWORDS' | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-chip-listbox>
            @for (keyword of conversation()?.keywordsV2; track keyword.keyword) {
              <mat-chip
                (click)="onTimeStampSelected(keyword.timestamp || 0)"
                [glxyTooltip]="keyword.timestamp || 0 | meetingAnalysisDuration"
                >{{ keyword.keyword }}
              </mat-chip>
            }
          </mat-chip-listbox>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="row row-gutters">
    <div class="col col-xs-12 col-sm-12 col-md-12">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            {{ 'INSIGHTS.CLARITY_REPORT.TITLE' | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div>
            <span class="secondary-score-title">{{
              'INSIGHTS.CLARITY_REPORT.PRONUNCIATION_AND_PACE' | translate
            }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.clarityReport?.pronunciationAndPaceScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{
              'INSIGHTS.CLARITY_REPORT.LANGUAGE_AND_SIMPLICITY' | translate
            }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.clarityReport?.languageSimplicityScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{
              'INSIGHTS.CLARITY_REPORT.STRUCTURE_AND_ORGANIZATION' | translate
            }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.clarityReport?.structureAndOrganizationScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.CLARITY_REPORT.ACTIVE_LISTENING' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.clarityReport?.activeListeningScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.CLARITY_REPORT.LIMITED_FILLERS' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.clarityReport?.limitedFillersScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.CLARITY_REPORT.OBJECTION_HANDLING' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.clarityReport?.objectionHandlingScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div class="score-reasoning">
            <span class="title">{{ 'INSIGHTS.CLARITY_REPORT.TOTAL_SCORE' | translate }}</span>
            <span class="score">
              <meeting-analysis-score-badge [score]="conversation()?.clarityReport?.totalScore || 0" [maxScore]="30">
              </meeting-analysis-score-badge
            ></span>
            <ul>
              <li>{{ conversation()?.clarityReport?.scoreReasoning }}</li>
            </ul>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="row row-gutters">
    <div class="col col-xs-12 col-sm-12 col-md-12">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            {{ 'INSIGHTS.RECOMMENDATIONS' | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          @for (item of conversation()?.recommendations || []; track item) {
            <div class="insight-container">
              <span class="title">{{ item.coachingAdvice }}</span>
            </div>
            <ul>
              <li
                meeting-analysis-video-jump
                [text]="item.observation || ''"
                [duration]="item.timestamp || 0"
                (click)="onTimeStampSelected(item.timestamp || 0)"
              ></li>
            </ul>
          }
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="row row-gutters">
    <div class="col col-xs-12 col-sm-12 col-md-6">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            {{ 'INSIGHTS.HIGHLIGHTS' | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul class="list-with-no-title">
            @for (item of conversation()?.highlights || []; track item) {
              <li
                meeting-analysis-video-jump
                [text]="item.highlight || ''"
                [duration]="item.timestamp || 0"
                (click)="onTimeStampSelected(item.timestamp || 0)"
              ></li>
            }
          </ul>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col col-xs-12 col-sm-12 col-md-6">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            {{ 'INSIGHTS.LOWLIGHTS' | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul class="list-with-no-title">
            @for (item of conversation()?.lowlights || []; track item) {
              <li
                meeting-analysis-video-jump
                [text]="item.lowlight || ''"
                [duration]="item.timestamp || 0"
                (click)="onTimeStampSelected(item.timestamp || 0)"
              ></li>
            }
          </ul>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="row row-gutters">
    <div class="col col-xs-12 col-sm-12 col-md-6">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            {{ 'INSIGHTS.PAIN_POINTS' | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          @for (item of conversation()?.topPainPoints; track item.painPoint) {
            <div class="insight-container">
              <span class="title">{{ item.painPoint }}</span>
            </div>
            <ul>
              <li
                meeting-analysis-video-jump
                [text]="item.reason || ''"
                [duration]="item.timestamp || 0"
                (click)="onTimeStampSelected(item.timestamp || 0)"
              ></li>
            </ul>
          }
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col col-xs-12 col-sm-12 col-md-6">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            {{ 'INSIGHTS.SELLING_OPPORTUNITIES' | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          @for (item of conversation()?.topSellingOpportunities; track item.opportunity) {
            <div class="insight-container">
              <span class="title">{{ item.opportunity }}</span>
            </div>
            <ul>
              <li
                meeting-analysis-video-jump
                [text]="item.reason || ''"
                [duration]="item.timestamp || 0"
                (click)="onTimeStampSelected(item.timestamp || 0)"
              ></li>
            </ul>
          }
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="row row-gutters">
    <div class="col col-xs-12 col-sm-12 col-md-12">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            {{ 'INSIGHTS.RAVEN.TITLE' | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="insight-container">
            <span class="title">{{ 'INSIGHTS.RAVEN.RAPPORT_AND_CONTEXT' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.ravenFramework?.rapportAndContext?.score || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <ul>
            <li>{{ conversation()?.salesMethodology?.ravenFramework?.rapportAndContext?.comments }}</li>
          </ul>
          <div class="insight-container">
            <span class="title">{{ 'INSIGHTS.RAVEN.ASSESSMENT_AND_DISCOVERY' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.ravenFramework?.assessmentAndDiscovery?.score || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <ul>
            <li>{{ conversation()?.salesMethodology?.ravenFramework?.assessmentAndDiscovery?.comments }}</li>
          </ul>
          <div class="insight-container">
            <span class="title">{{ 'INSIGHTS.RAVEN.VALUE_DELIVERY' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.ravenFramework?.valueDelivery?.score || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <ul>
            <li>{{ conversation()?.salesMethodology?.ravenFramework?.valueDelivery?.comments }}</li>
          </ul>
          <div class="insight-container">
            <span class="title">{{ 'INSIGHTS.RAVEN.ENGAGEMENT_AND_OBJECTION_HANDLING' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.ravenFramework?.engagementAndObjectionHandling?.score || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <ul>
            <li>{{ conversation()?.salesMethodology?.ravenFramework?.engagementAndObjectionHandling?.comments }}</li>
          </ul>
          <div class="insight-container">
            <span class="title">{{ 'INSIGHTS.RAVEN.NEXT_STEPS_AND_OWNERSHIP' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.ravenFramework?.nextStepsAndOwnership?.score || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <ul>
            <li>{{ conversation()?.salesMethodology?.ravenFramework?.nextStepsAndOwnership?.comments }}</li>
          </ul>
          <div class="score-reasoning">
            <span class="title">{{ 'INSIGHTS.CLARITY_REPORT.TOTAL_SCORE' | translate }}</span>
            <span class="score">
              <meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.ravenFramework?.totalScore || 0"
                [maxScore]="25"
              >
              </meeting-analysis-score-badge
            ></span>
            <ul>
              <li>{{ conversation()?.salesMethodology?.ravenFramework?.totalScoreComments }}</li>
            </ul>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="row row-gutters">
    <div class="col col-xs-12 col-sm-12 col-md-12">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            {{ 'INSIGHTS.BANT.TITLE' | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.BANT.BUDGET_SCORE' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.bant?.budgetScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.BANT.AUTHORITY_SCORE' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.bant?.authorityScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.BANT.NEED_SCORE' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.bant?.needScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.BANT.TIMELINE_SCORE' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.bant?.timelineScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div class="score-reasoning">
            <div class="title">{{ 'INSIGHTS.SCORE_REASONING' | translate }}</div>
            <ul>
              @for (reason of conversation()?.salesMethodology?.bant?.explanations || []; track reason.explanation) {
                <li
                  meeting-analysis-video-jump
                  [text]="reason.explanation || ''"
                  [duration]="reason.timestamp || 0"
                  (click)="onTimeStampSelected(reason.timestamp || 0)"
                ></li>
              }
            </ul>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="row row-gutters">
    <div class="col col-xs-12 col-sm-12 col-md-12">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            {{ 'INSIGHTS.MEDPICC_SCORE.TITLE' | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.MEDPICC_SCORE.METRICS_SCORE' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.medpicc?.metricsScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.MEDPICC_SCORE.ECONOMIC_BUYER_SCORE' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.medpicc?.economicBuyerScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{
              'INSIGHTS.MEDPICC_SCORE.DECISION_CRITERIA_SCORE' | translate
            }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.medpicc?.decisionCriteriaScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.MEDPICC_SCORE.DECISION_PROCESS_SCORE' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.medpicc?.decisionProcessScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.MEDPICC_SCORE.PAPER_SCORE' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.medpicc?.paperScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.MEDPICC_SCORE.IDENTIFY_PAIN_SCORE' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.medpicc?.identifyPainScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.MEDPICC_SCORE.CHAMPION_SCORE' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.medpicc?.championScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.MEDPICC_SCORE.COMPETITION_SCORE' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.medpicc?.competitionScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div class="score-reasoning">
            <div class="title">{{ 'INSIGHTS.SCORE_REASONING' | translate }}</div>
            <ul>
              @for (reason of conversation()?.salesMethodology?.medpicc?.explanations || []; track reason.explanation) {
                <li
                  meeting-analysis-video-jump
                  [text]="reason.explanation || ''"
                  [duration]="reason.timestamp || 0"
                  (click)="onTimeStampSelected(reason.timestamp || 0)"
                ></li>
              }
            </ul>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="row row-gutters">
    <div class="col col-xs-12 col-sm-12 col-md-12">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            {{ 'INSIGHTS.SANDLER_SCORE.TITLE' | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div>
            <span class="secondary-score-title">{{
              'INSIGHTS.SANDLER_SCORE.BONDING_AND_RAPPORT_SCORE' | translate
            }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.sandler?.bondingAndRapportScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.SANDLER_SCORE.UPFRONT_CONTRACT_SCORE' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.sandler?.upFrontContractScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.SANDLER_SCORE.PAIN_SCORE' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.sandler?.painScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.SANDLER_SCORE.BUDGET_SCORE' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.sandler?.budgetScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.SANDLER_SCORE.DECISION_SCORE' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.sandler?.decisionScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.SANDLER_SCORE.FULFILLMENT_SCORE' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.sandler?.fulfillmentScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.SANDLER_SCORE.POST_SELL_SCORE' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.sandler?.postSellScore || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div class="score-reasoning">
            <div class="title">{{ 'INSIGHTS.SCORE_REASONING' | translate }}</div>
            <ul>
              @for (reason of conversation()?.salesMethodology?.sandler?.explanations || []; track reason.explanation) {
                <li
                  meeting-analysis-video-jump
                  [text]="reason.explanation || ''"
                  [duration]="reason.timestamp || 0"
                  (click)="onTimeStampSelected(reason.timestamp || 0)"
                ></li>
              }
            </ul>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="row row-gutters">
    <div class="col col-xs-12 col-sm-12 col-md-12">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            {{ 'INSIGHTS.SOLUTION_SELLING_SCORE.TITLE' | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div>
            <span class="secondary-score-title">{{
              'INSIGHTS.SOLUTION_SELLING_SCORE.SITUATION_KNOWLEDGE' | translate
            }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.solutionSelling?.situationKnowledge || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{
              'INSIGHTS.SOLUTION_SELLING_SCORE.CAPABILITY_KNOWLEDGE' | translate
            }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.solutionSelling?.capabilityKnowledge || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{ 'INSIGHTS.SOLUTION_SELLING_SCORE.PEOPLE_SKILLS' | translate }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.solutionSelling?.peopleSkills || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div>
            <span class="secondary-score-title">{{
              'INSIGHTS.SOLUTION_SELLING_SCORE.SELLING_SKILLS' | translate
            }}</span>
            <span class="score"
              ><meeting-analysis-score-badge
                [score]="conversation()?.salesMethodology?.solutionSelling?.sellingSkills || 0"
                [maxScore]="5"
              ></meeting-analysis-score-badge
            ></span>
          </div>
          <div class="score-reasoning">
            <div class="title">{{ 'INSIGHTS.SCORE_REASONING' | translate }}</div>
            <ul>
              @for (
                reason of conversation()?.salesMethodology?.solutionSelling?.explanations || [];
                track reason.explanation
              ) {
                <li
                  meeting-analysis-video-jump
                  [text]="reason.explanation || ''"
                  [duration]="reason.timestamp || 0"
                  (click)="onTimeStampSelected(reason.timestamp || 0)"
                ></li>
              }
            </ul>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
